import { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import {
  Button,
  CircularProgress,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { CloudUploadOutlined } from "@mui/icons-material";
import { isValidImage } from "../../api/helpers";

const StyledContainer = styled(Stack)`
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 80%;
  transform: translate(-50%, -50%);
  gap: 4em;
  outline: none;
`;

const StyledImage = styled(Box)`
  width: clamp(250px, 100%, 800px);
  max-height: 60vh;
  border: 2px solid #000;
`;

const StyledButtonContainer = styled(Stack)`
  align-items: center;
  width: 100%;
`;

const ImageModal = ({
  imageUrl,
  modalOpen,
  onModalClose,
  onNewImageConfirmed,
  imageUploadObj,
}) => {
  const [validImage, setValidImage] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const result = await isValidImage(imageUrl);
        setValidImage(result);
      } catch (error) {
        setValidImage(false);
      }
    })();
  }, []);

  const handleImageChange = (event) => {
    if (event.target.files.length) {
      const file = event.target.files[0];
      imageUploadObj?.setNewImage(file);
    }
  };

  const handleModalClosed = () => {
    onModalClose();
    setTimeout(() => imageUploadObj?.reset(), 250);
  };

  const handleImageSaved = async (event) => {
    event.preventDefault();
    onNewImageConfirmed();
  };

  return (
    <Modal
      open={modalOpen}
      onClose={handleModalClosed}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={modalOpen}>
        <StyledContainer>
          <Stack alignItems="center">
            {imageUploadObj?.previewImageUrl &&
              <Typography
                variant="overline"
                fontWeight="bold"
                fontSize="xx-large"
                color={theme => theme.palette.getContrastText(
                  theme.palette.background.paper)}
              >
                **Preview**
              </Typography>}
            {imageUploadObj?.previewImageUrl ? (
              <StyledImage
                component="img"
                src={imageUploadObj?.previewImageUrl}
              />
            ) : (
              <>
                {validImage && <StyledImage
                  component="img"
                  src={imageUrl}
                />}
              </>
            )}
          </Stack>
          {onNewImageConfirmed !== undefined && <StyledButtonContainer>
            {imageUploadObj?.previewImageUrl ? (
              <>
                {imageUploadObj?.uploadPercentage === 0 && <Stack
                  direction="row"
                  spacing={2}
                >
                  <Button
                    variant="contained"
                    onClick={imageUploadObj?.reset}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    onClick={handleImageSaved}
                  >
                    Save
                  </Button>
                </Stack>}
                {imageUploadObj?.uploadPercentage > 0 &&
                  imageUploadObj?.uploadPercentage < 100 &&
                  <CircularProgress
                    variant="determinate"
                    value={imageUploadObj?.uploadPercentage}
                  />}
                {imageUploadObj?.uploadPercentage === 100 &&
                  <CircularProgress/>}
              </>
            ) : (
              <Button
                variant="contained"
                component="label"
                startIcon={<CloudUploadOutlined/>}
              >
                Upload New Image
                <input
                  type="file"
                  name="profileImage"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                />
              </Button>
            )}
          </StyledButtonContainer>}
        </StyledContainer>
      </Fade>
    </Modal>
  );
};

export default ImageModal;